enum OptionalModule {
    UserDefinedFunctions = 'User Defined functions',
    CacheKeys = 'Cache Keys',
    Variables = 'Variables',
    Aggregation = 'Aggregation',
    EndPointFilteringLogic = 'End Point Filtering Logic',
    ExpectedUnderReportLogic = 'Expected Under report Logic',
    ExpectedOverReportLogic = 'Expected Over report Logic',
    Dictionary = 'Dictionary',
    MatchingKeys = 'Matching Keys'
}

export default OptionalModule;